module.exports = __webpack_public_path__ + "a562c999f8217446897ab98f7429a99c.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sp-admin/details/company-details.html
// module id = 1965
// module chunks = 0